import { useErrorReporter } from '@/composables/useErrorReporter'
// import type { ISbStoriesParams } from 'storyblok-js-client'
import { STORYBLOK_VERSION } from '@/constants/index.js'
import { useI18n } from 'vue-i18n'

export function useStoryblokWithErrorReporting() {
	const { bugsnagReport } = useErrorReporter()
	const { locale } = useI18n({
		useScope: 'global'
	})

	const getStory = async (contentPage: string) => {
		const storyblokApi = useStoryblokApi()
		const {
			data, error
		} = await useAsyncData(
			`storyblok-${contentPage}-${locale.value}`,
			async () => await storyblokApi.get(`cdn/stories/${contentPage}`, {
				version: STORYBLOK_VERSION,
				language: locale.value
			})
		)
		if (error?.value) {
			bugsnagReport({
				error: new Error('Storyblok did not return an story'),
				showToast: true
			})
			throw createError({
				statusCode: 404,
				statusMessage: 'Page Not Found',
				fatal: true
			})
		}
		return data
	}

	return {
		getStory
	}
}
